import { formatDate } from '../formatDate'
import { IOptions } from '../../constants/types/common.types'

const formatSelect = (answers: IOptions[]) => {
  const addition = answers.length > 1 ? ', ...' : ''
  return answers[0] ? answers[0].label + addition : ''
}

const formatCheckbox = (options: any[]) => (answer: string[]) => {
  const found = options.find((item) => item.value === answer[0])
  const addition = answer.length > 1 ? ', ...' : ''
  return found ? found.label + addition : ''
}

const formatDateParam = (answer: Date[]): string => {
  const fomatedDates = answer.map((item) => formatDate(item))
  return fomatedDates.filter((item) => item).join('-')
}

export { formatSelect, formatCheckbox, formatDateParam }
